import { useI18nDownloadLink } from 'src/i18n/useI18nDownloadLink'
import { documentLinks } from 'src/business/static-pages/content/documentLinks'

export const useI18nDownloadTradingTermsLink = () =>
    useI18nDownloadLink(documentLinks.tradingTerms)
